import { render, staticRenderFns } from "./PDropDownContainer.vue?vue&type=template&id=457586f6&scoped=true&"
import script from "./PDropDownContainer.vue?vue&type=script&lang=ts&"
export * from "./PDropDownContainer.vue?vue&type=script&lang=ts&"
import style0 from "./PDropDownContainer.vue?vue&type=style&index=0&id=457586f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457586f6",
  null
  
)

export default component.exports